'use client';

import classNames from 'classnames';
import styles from './Item.module.scss';

interface ItemBaseProps {
  className: string;
}

interface ItemInfoProps extends ItemBaseProps {
  item: {
    listNumber: number;
    title: string;
    description: string;
  }
  video?: never;
}

interface ItemImageProps extends ItemBaseProps {
  video: string;
  item?: never;
}

type ItemProps = ItemInfoProps | ItemImageProps;

const Item = ({
  item,
  video,
  className,
}: ItemProps) => {
  const parsedUrl = (video || '').split('.');
  const ext = parsedUrl[parsedUrl.length - 1];

  return (
    <div className={classNames(styles.item, className, { [styles.item_isVideo]: !!video })}>
      {item ? (
        <div className={styles.item__text}>
          <h6 className={classNames(styles.item__title, 'header3')}>{`${item.listNumber}. ${item.title}`}</h6>
          <p className={styles.item__description}>{item.description}</p>
        </div>
      ) : (
        <video
          autoPlay
          loop
          muted
          playsInline
          className={styles.item__video}
          onClick={(e) => e.preventDefault()}
        >
          <source
            src={video}
            type={`video/${ext}`}
          />
          {`Your browser does not support ${ext} video with transparency.`}
        </video>
      )}
    </div>
  );
};

export default Item;
